import { useTranslation } from 'react-i18next';

export default function WhySection() {
  const { t } = useTranslation();
  const items: string[] = t('why.items', { returnObjects: true }) as unknown as string[];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            {t('why.title')}
          </h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">
            Kakobuy Spreadsheet to narzędzie, które zmienia sposób w jaki Polacy robią zakupy online. Oszczędzaj czas i pieniądze dzięki naszym codziennie aktualizowanym zestawieniom.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {items.map((item: string, idx: number) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 md:p-6 flex flex-col items-center text-center gap-3 hover:bg-background-50/80 transition-colors"
            >
              <div className="w-11 h-11 rounded-full bg-primary-50 flex items-center justify-center">
                <i className="ri-check-line text-primary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}